








































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import { getEmployeeList, enableOrDisableEmployee } from '@/api/employee'
import { getTitleIntegrityList } from '@/api/competition'
import { UserModule } from '@/store/modules/user'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'
import CryptoJS from 'crypto-js'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'Employee',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 50
  private tableData = []
  private id = ''
  private status = ''
  private title = ''
  private isSearch: boolean = false
  private titleId = ''
  private titleId1 = ''

  // 判断是否有权限
  private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin') || roles.includes('zhangsan')) return true;
    return false;
  }

  cancel() {
    this.$router.push({ path: '/competition' })
  }

  //状态修改
   private statusHandle(row: any) {
    if (row.username === 'admin') {
      return
    }
    this.id = row.id
    this.status = row.status
    this.type = 0
    this.$confirm('确认调整该赛事的状态?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      enableOrDisableCompetition({ id: this.id, status: !this.status ? 1 : 0,type: this.type })
        .then((res) => {
          if (String(res.status) === '200') {
            this.$message.success('赛事状态更改成功！')
            this.init()
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  created() {
    if (this.$route.query.titleId) {
      this.titleId1 = this.$route.query.titleId
      this.title = this.$route.query.title
    }
    this.name()
    this.init()
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  copyLink() {
    const link = `https://blog.alexbetter.cn/performanceDisplay/index.html?titleId=${this.titleId}&round=0`;

    navigator.clipboard.writeText(link).then(() => {
      // 复制成功
      this.$message.success('成绩看板链接已复制到剪贴板');
    }).catch(err => {
      // 复制失败，使用备用方法
      console.error('复制失败:', err);
      this.fallbackCopyText(link);
    });
  }

  // 获取赛事完整度列表
  private async init(isSearch?: boolean) {
    this.isSearch = true
    const params = {
      content: this.input ? this.input : undefined,
      titleId: this.titleId,
      type: 1,
    }
    await getTitleIntegrityList(params).then((res) => {
      if (String(res.data.code) === '1') {
          this.tableData = res.data.data
          // console.log(this.tableData)
        }
    })
    .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
  }


  // 新建赛事
  private addCompetitionHandle() {
      this.$router.push({ path: '/competition/add', query: { titleId: this.titleId1, title: this.title } })
  }

  // 小程序管理
  private smallProgramManageHandle() {
      this.$router.push({ path: '/competition/smallProgramManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 客服管理
  private serviceManageHandle() {
      this.$router.push({ path: '/competition/serviceManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 热度管理
  private titleManageHandle() {
      this.$router.push({ path: '/competition/hotManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 公告管理
  private noticeManageHandle() {
      this.$router.push({ path: '/competition/noticeManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 宣传图管理
  private promotionalImageManageHandle() {
      this.$router.push({ path: '/competition/promotionalImageManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 轮播图管理
  private recordingPictureManageHandle() {
      this.$router.push({ path: '/competition/recordingPictureManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 奖品详情管理
  private prizeDetailsManageHandle() {
      this.$router.push({ path: '/competition/prizeDetailsManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 赛事规则管理
  private eventRulesManageHandle() {
      this.$router.push({ path: '/competition/eventRulesManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 赛事介绍管理
  private eventIntroductionManageHandle() {
      this.$router.push({ path: '/competition/eventIntroductionManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 选手管理
  private playerManageHandle() {
      this.$router.push({ path: '/competition/playerManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 参赛选手管理
  private votingRecordsManageHandle() {
      this.$router.push({ path: '/competition/scoreManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 成绩管理
  private scoreManageHandle() {
      this.$router.push({ path: '/competition/scoreRoundManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 礼物管理
  private giftManageHandle() {
      this.$router.push({ path: '/competition/giftManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 赛事直播管理
  private liveStreamingManageHandle() {
      this.$router.push({ path: '/competition/liveStreamingManage', query: { titleId: this.titleId1, title: this.title } })
  }

  // 开屏管理
  private userOpenManageHandle() {
      this.$router.push({ path: '/competition/userOpenManage', query: { titleId: this.titleId1, title: this.title } })
  }


  // 喔图管理
  private openManageHandle() {
      this.$router.push({ path: '/competition/openManage', query: { titleId: this.titleId1, title: this.title } })
  }
}
